import React from 'react';
import { Dialog } from 'primereact/dialog';

export const CustomDialog = (props) => {
  // eslint-disable-next-line react/prop-types
  const { visible, onHide, header, body, footer } = props

  return (
    <div>
      <Dialog
        visible={visible}
        header={header}
        onHide={onHide}
        style={{ width: "380px" }}
        footer={footer}
        headerClassName='dialog-header'
      >
        {body}
      </Dialog>
    </div>
  )

}